import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from 'reducers';

const loggerMiddleware = createLogger();

let middlewareToApply = [thunkMiddleware]
if(process.env.NODE_ENV !== 'development'){
    middlewareToApply = [thunkMiddleware, loggerMiddleware]
}

export const store = createStore(
    rootReducer,
    applyMiddleware(...middlewareToApply)
);
